import { useContext } from 'react';
import SectionContext from '../../SectionContext';
import ModelsContext from '../../../../ModelsContext';
import useApi from '@/lib/api/useApi';
import { type EditorSection } from '@/lib/types';
import SelectedModelIdContext from '../../../../SelectedModelIdContext';

const useSectionMoving = (): [() => void, () => void] => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const { section, previousSection, nextSection } = useContext(SectionContext);

  const swapPositionsWithSection = async (
    sectionToSwapWith: EditorSection,
  ): Promise<void> => {
    await api.post(
      `editor/challenge-model/sections/${section.id}/position/swap/${sectionToSwapWith.id}`,
    );

    setModels(models => {
      models[selectedModelId].sections[section.id].position =
        sectionToSwapWith.position;
      models[selectedModelId].sections[sectionToSwapWith.id].position =
        section.position;
    });
  };

  const moveUp = (): void => {
    if (previousSection !== null) {
      swapPositionsWithSection(previousSection);
    }
  };

  const moveDown = (): void => {
    if (nextSection !== null) {
      swapPositionsWithSection(nextSection);
    }
  };

  return [moveUp, moveDown];
};

export default useSectionMoving;
